
import leftArrow from "./assets/leftArrow.svg"

function Header(props) {
 const { title, onBack, showBackButton } = props;
 
 return (
  <div className="tr-header">
   <div style={{ position: 'relative' }}>
    {showBackButton&&<div style={{ position: 'absolute', left: '20px', width: '50px', lineHeight: '50px' }} onClick={onBack}>
     <img className="screen-close-icon" src={leftArrow} alt="back arrow" />
    </div>}
    <div style={{ height: '50px', width: '100%' }} className=" d-flex vertical-center horizontal-center"> {title}</div>
   </div>
  </div>
 );
}
export default Header;